import type { CallSummary, ConversionSummary } from "./api/calls";
import { buildCallKpis } from "./calls-kpis";

export function operationDay(now = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" }).format(now);
}

export function validateDailyResultsSearch(raw: Record<string, unknown>): { day?: string } {
  if (typeof raw.day !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(raw.day)) return {};
  const parsed = new Date(`${raw.day}T12:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === raw.day
    ? { day: raw.day }
    : {};
}

// Os registros desta operação usam o horário de Brasília (UTC-3).
export function dailyResultsWindow(day: string) {
  return {
    from: new Date(`${day}T00:00:00.000-03:00`).toISOString(),
    to: new Date(`${day}T23:59:59.999-03:00`).toISOString(),
  };
}

export function dailyResultsMetrics(summary: CallSummary, crm?: ConversionSummary) {
  const calls = buildCallKpis(summary);
  return {
    ...calls,
    contacts: summary.humanContacts ?? calls.answered.count,
    voicemail: summary.voicemail ?? null,
    inProgress: summary.byStatus
      .filter((row) => row.status === "RINGING" || row.status === "IN_PROGRESS")
      .reduce((sum, row) => sum + row.count, 0),
    conversions: crm?.totals.conversions ?? null,
    workedLeads: crm?.totals.workedLeads ?? null,
    losses: crm?.totals.losses ?? null,
    conversionRate: crm && crm.totals.workedLeads > 0 ? crm.totals.rate : null,
    contactRate:
      summary.totalCalls > 0
        ? ((summary.humanContacts ?? calls.answered.count) / summary.totalCalls) * 100
        : null,
  };
}

export function dailyResultsHours(summary: CallSummary, day: string) {
  if (!summary.perHour) return null;
  const hours = new Map(summary.perHour.map((row) => [row.hour, row]));
  return Array.from({ length: 24 }, (_, index) => {
    const hour = `${String(index).padStart(2, "0")}:00`;
    const row = hours.get(`${day}T${hour}`);
    return { hour, total: row?.total ?? 0, failed: row?.failed ?? 0 };
  });
}
